import React, { useState, useEffect } from 'react';
import Network from '../../../models/Network.js';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';

import CheckFlagListElement from '../list_elements/CheckFlagListElement.js';
import './Module.css';

const key = process.env.REACT_APP_CLIENT_ACCESS_KEY;
const URLS = require("../../../urls.js");

const StatusCodes = require('../../../status-codes/status-codes.js')
const ErrorCodes = require('../../../error-codes/error-codes.js')

const testOldCode = `Med 12 responded for report of problem unknown, reported spanish speaking male used 911 only phone to say he needed an ambo and hung up. U/A found 43 y/o M standing outside home speaking with PD and FD. Pt reports he has noted ulcerations appearing on his L lower leg over the past week. Pt reports he also has a dull generalized HA. During pt interview pt reported he was a Type II diabetic but reports he doesn't fill his rx. Pt reported he has gone to the ER before and his BGL was high and they wanted to keep him but he did not want to stay for an extended admission. Pt denies dizziness, CP, SOB, cough, abd pain, n/v/d, back/flank pain, body ache, fever or chills. Pt reported he did not call 911 and does not want EMS, reports he called his sister and she is coming to take him to the ED. Pt advised that his BGL was HI and it was very important that he seek medical attention and transport was offered and refused multiple times. No other complaints at time of EMS assessment. PMH/Meds - as documented Allergies - as documented HEENT - No TIC, abrasions, contusions, lacerations, deformities or other external evidence of injury. PERRL 3mm, OP clear. Chest - no TIC, no bruising. Lungs -CTAB, no increased WOB. Abd - soft NT/ND, no bruising. Pelvis - stable, nontender. UE/LE - ulcerations noted to L lower leg with signs of PVD - skin discoloration, etc to LE bilaterally distal to knees, otherwise no TIC, abrasions, contusions, lacerations, deformities or other external evidence of injury. Motor 5/5, sensory grossly intact, 2+ radial pulses. Normal ROM in major joints without pain or limitation. Neck/back - no midline or lateral ttp, no posterior chest wall or flank pain, no deformities or bruising. Skin W/P/D. CA&Ox4. GCS 15. Speech fluent and clear, appropriately conversive. VS as documented BGL - HI Pt strongly advised to accept transport to the ED via EMS. Advised his BGL was very high and leaving DM untreated for extended periods of time can be dangerous. Pt continued to decline transport by EMS and reported his sister was on her way and she would be there soon and he would have her take him to the ED so she could stay with his 13 yr old daughter. Pt strongly advised to make sure he did go to the ER as soon as the sister arrived for further evaluation and tx. Pt verbalized understanding refusal was AMA and that he would seek treatment POV. Refusal signed by pt. Med 12 returned in-service.`;
const testNewCode = `Med 12 responded for report of problem  male used 911 only phone to say he needed an ambo and hung up. New sentence. U/A found 43 y/o M standing outside home speaking with PD and FD. Pt reports he has noted ulcerations appearing on his L lower leg over the past week. Pt reports he also has a dull generalized HA. During pt interview pt reported he was a Type II diabetic but reports he doesn't fill his rx. New sentence. Pt reported he has gone to the ER before and his BGL was high and they wanted to keep him but he did not want to stay for an extended admission. Pt denies dizziness, CP, SOB, cough, abd pain, n/v/d, back/flank pain, body ache, fever or chills. Pt reported he did not call 911 and does not want EMS, reports he called his sister and she is coming to take him to the ED. Pt advised that his BGL was HI and it was very important that he seek medical attention and transport was offered and refused multiple times. No other complaints at time of EMS assessment. PMH/Meds - as documented Allergies - as documented HEENT - No TIC, abrasions, contusions, lacerations, deformities or other external evidence of injury. Lungs -CTAB, no increased WOB. Abd - soft NT/ND, no bruising. Pelvis - stable, nontender. UE/LE - ulcerations noted to L lower leg with signs of PVD - skin discoloration, etc to LE bilaterally distal to knees, otherwise no TIC, abrasions, contusions, lacerations, deformities or other external evidence of injury. Motor 5/5, sensory grossly intact, 2+ radial pulses. Normal ROM in major joints without pain or limitation. Neck/back - no midline or lateral ttp, no posterior chest wall or flank pain, no deformities or bruising. New sentence. New sentence. Skin W/P/D. CA&Ox4. GCS 15. Speech fluent and clear, appropriately conversive. VS as documented BGL - HI Pt strongly advised to accept transport to the ED via EMS. Advised his BGL was very high and leaving DM untreated for extended periods of time can be dangerous. Pt continued to decline transport by EMS and reported his sister was on her way and she would be there soon and he would have her take him to the ED so she could stay with his 13 yr old daughter. Pt strongly advised to make sure he did go to the ER as soon as the sister arrived for further evaluation and tx. New sentence. He would seek treatment POV. Refusal signed by pt. Med 12 returned in-service. New sentence.`;

const ReportAiNarrativeModule = ({user, reportId, isSmallScreen}) => {
    const [reportData, setReportData] = useState(null);
    const [aiFlagsData, setAiFlagsData] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [oldNarrative, setOldNarrative] = useState('no old narrative set');
    const [newNarrative, setNewNarrative] = useState('no new narrative set');

    const handleOpen = () => {
        setIsOpen(!isOpen);
    }

    // function that gets one reports from the server
    const getOneReport = async (reportId) => {
        const url = URLS.GET_ONE_REPORT;
        const dict = {
            uid: user.uid,
            report_id: reportId,
            CLIENT_ACCESS_KEY: key
        };
        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;
            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something

            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")

            } else {
                console.log("Unknown Error")
            }
        });
        return responseData;
    };

    // function that gets one report's ai flags from the server
    const getOneReportAiFlags = async (reportId) => {
        const url = URLS.GET_ONE_REPORT_AI_FLAGS;
        const dict = {
            uid: user.uid,
            report_id: reportId,
            CLIENT_ACCESS_KEY: key
        };
        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;
            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something

            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")

            } else {
                console.log("Unknown Error")
            }
        });
        return responseData;
    };

    useEffect(() => {
        getOneReport(reportId)
            .then((data) => {
                setOldNarrative(data[0].narrative);
                setReportData(data);
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, []);

    useEffect(() => {
        getOneReportAiFlags(reportId)
            .then((data) => {
                // console.log('data length:', data.length);
                // console.log('data:', data[data.length - 1].generated_text);
                // iterate through the data and find the element where the key "feedback_disignation" is "modified_narrative"
                // then set new narrative to that element's generated_text
                // then remove that element from the data array
                for (let i = 0; i < data.length; i++) {
                    if (data[i].feedback_designation === "modified_narrative") {
                        setNewNarrative(data[i].generated_text);
                        console.log('new narrative:', data[i].generated_text);
                        data.splice(i, 1); // remove the element from the array
                        console.log('data:', data); // check if the element was removed
                    }
                }
                setAiFlagsData(data);
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, []);

    const handleOverrideButtonClick = (checkOrFlag) => {
        // let checkFlagToUpdate = {
        //     checkFlagData:checkOrFlag['checkFlagData'],
        //     overriddenStatus: checkOrFlag['overriddenStatus'],
        //     objectType: checkOrFlag['objectType']
        // };
        // // console.log('checkToUpdate (parent, extracted):', checkToUpdate)
        // setCheckFlagToUpdate(checkFlagToUpdate);
    };

    const createCheckFlagListElement = (data) => {
        return (
            true ? ( // always show for now
                <CheckFlagListElement
                    data={data}
                    onButtonClick={handleOverrideButtonClick}
                    />
            ) : null
        );
    };

    return (
        <div className={isSmallScreen ? "standard-module-screen-small" : "standard-module"}>
            <div>
                <h2 className='module-title'>Narrative Feedback</h2>
            </div>
            <div className="qna">

                {aiFlagsData ? (
                    <div>
                        {aiFlagsData.map((aiFlag) => (createCheckFlagListElement(aiFlag)))}
                    </div>
                ) : (
                    <div>Loading Report Data...</div>
                )}

                <div className="enter-button" onClick={e => handleOpen()}>
                    Click here to view suggested changes to the narrative: 
                    <i className={isOpen ? "fa-solid fa-chevron-down" : "fa-solid fa-chevron-up"}></i>
                </div>

                {isOpen && (
                    <ReactDiffViewer
                        oldValue={oldNarrative}
                        newValue={newNarrative}
                        splitView={false}
                        disableWordDiff={false}
                        hideLineNumbers={true}
                        hideMarkers={true}
                        showDiffOnly={false}
                        compareMethod={DiffMethod.WORDS}
                    />
                )}
            </div>
        </div>
    );
}

export default ReportAiNarrativeModule;